import React from 'react';
export function Logo() {
  return <div className="flex items-center justify-center gap-2.5" data-id="element-36" data-mp="30xo6g74evtgp">
      <span className="flex h-9 w-9 items-center justify-center rounded-md bg-[#0E3B42] font-display text-xl font-bold leading-none text-white" aria-hidden="true" data-id="element-37" data-mp="8tcwhcqjvxy4">
        K
      </span>
      <span className="text-[13px] font-extrabold uppercase tracking-[0.2em] text-[#0E3B42]" data-id="element-38" data-mp="3v9pk8whiwbga">
        Dott.ssa Karito
      </span>
    </div>;
}